module.exports = __webpack_public_path__ + "VIPH17.png?274f72815b7f0fc0c4a3984544efc308";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH17.png
// module id = 89
// module chunks = 0